export default {
    getRuns:      { method: 'get',  url: 'join-generation-runs' },
    getRun:       { method: 'get',  url: 'join-generation-runs/{id}' },
    getRunErrors: { method: 'get',  url: 'join-generation-runs/{id}/errors' },
    startRun:     { method: 'post', url: 'join-generation-runs' },
    cancelRun:    { method: 'post', url: 'join-generation-runs/{id}/cancel' },
}
